module.exports = __webpack_public_path__ + "9c7aa698f9d5661914edebb42c46315e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/fries-s.png
// module id = 2028
// module chunks = 0